import { SharedGridStyle } from "features/CenterContent/shared/MainContentGrid";
import { HeadedContainerSticky } from "features/CenterContent/VehicleDetails/shared/HeadedContainerSticky";
import { useInfoMessages } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/getInfoMessages";
import { OperationalTrainInfoHeader } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/OperationalTrainInfoHeader";
import { useTrainInformationFromURLParams } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/useTrainInformation";
import { useTrainInternalMessage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/useTrainInternalMessages";
import { DetailsParams } from "features/CenterContent/VehicleDetails/TrainDetails/TrainDetails";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import { NoDataMessage } from "shared/components/feedback/NoDataMessage/NoDataMessage";
import { Flex } from "shared/components/Spor";
import styled from "styled-components";

const TrainInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  width: 100%;
  min-height: 85px;
`;

const OperationalTrainInfoContent = () => {
  const { trainNumber, trainDate, countryCode } = useParams<DetailsParams>();
  const internalMessagesInformation = useTrainInternalMessage();
  const trainInformation = useTrainInformationFromURLParams();
  const { t } = useTranslation();

  const infoMessages = useInfoMessages(
    trainInformation,
    internalMessagesInformation,
  );

  if (
    trainNumber === undefined ||
    trainDate === undefined ||
    countryCode === undefined
  ) {
    return (
      <FailureMessage
        customMessage={t(
          "Kunne ikke hente tognummer eller dato for dette toget.",
        )}
      />
    );
  }

  if (Array.isArray(infoMessages) && infoMessages.length === 0) {
    return (
      <Flex flex={1}>
        <NoDataMessage
          reason={t("Fant ingen registrerte hendelser på dette toget.")}
        />
      </Flex>
    );
  }

  return <TrainInfoWrapper>{infoMessages}</TrainInfoWrapper>;
};

export const OperationalTrainInfo = () => (
  <HeadedContainerSticky
    panelStyle={SharedGridStyle}
    headerHeight="54px"
    variant="main"
    header={<OperationalTrainInfoHeader />}
  >
    <OperationalTrainInfoContent />
  </HeadedContainerSticky>
);
